import { configureStore } from "@reduxjs/toolkit";
import { sellerReducer } from "./reducers/admin";
import { productReducer } from "./reducers/product";
import { cartReducer } from "./reducers/cart";
import { wishlistReducer } from "./reducers/wishlist";
import { categoryReducer } from "./reducers/category";
import { subcategoryReducer } from "./reducers/Subcategory";
import { subsubcategoryReducer } from "./reducers/subsubcategory";
import { filterReducer } from "./reducers/filters";
import { parentColorReducer } from "./reducers/parentColor";
import { childColorReducer } from "./reducers/childColorReducer";

const Store = configureStore({
  reducer: {
    seller: sellerReducer,
    products: productReducer,
    parentColor: parentColorReducer,
    childcolor:childColorReducer,
    category: categoryReducer,
    subcategories: subcategoryReducer,
    subsubcategories: subsubcategoryReducer,
    cart: cartReducer,
    wishlist: wishlistReducer,
    filters: filterReducer, 
  },
});

export default Store;
